import { convertLocalDateDTOToDate, convertLocalDateToString } from '../../../utils/dateUtil';
import { Message } from '@flos/react-ui';
import type { LocalDateDTO } from 'gw-edge-client/dist/types/dto/pc/edge/time/';
import type { CoverageDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';

const displayCoverageWarning = (cancellationDate: LocalDateDTO, coverage: CoverageDTO): boolean => {
    if (!cancellationDate) return false;
    if (!coverage.publicID || !coverage.name || !coverage.effectiveDate) return false;
    return (
        convertLocalDateDTOToDate(cancellationDate) <
        convertLocalDateDTOToDate(coverage.effectiveDate)
    );
};
export const EDICancellationCoveragesLaterInForce = ({
    coverages,
    cancellationDate
}: {
    coverages?: CoverageDTO[];
    cancellationDate?: LocalDateDTO;
}): React.JSX.Element => {
    if (!coverages || !cancellationDate) return <></>;
    return (
        <>
            {coverages &&
                coverages.length > 0 &&
                coverages.map((coverage: CoverageDTO) => {
                    const { publicID, name, effectiveDate } = coverage;
                    return (
                        displayCoverageWarning(cancellationDate, coverage) && (
                            <div key={publicID}>
                                <Message
                                    id={`coverage-later-in-force-${publicID ?? ''}`}
                                    className="coverage-warning paragraph--small u-spacing-stack-s"
                                    theme="warning"
                                    title={`Vær opmærksom på at dækningen ”${String(
                                        name
                                    )}” først gælder fra ${
                                        (effectiveDate &&
                                            convertLocalDateToString(
                                                convertLocalDateDTOToDate(effectiveDate)
                                            )) ??
                                        ''
                                    }.`}
                                />
                            </div>
                        )
                    );
                })}
        </>
    );
};
